/** Mirrors the control-plane rules so the editor can flag problems before saving. */
export const SKILL_NAME_PATTERN = /^[a-z0-9][a-z0-9-]{0,63}$/;
const DESCRIPTION_MAX_LENGTH = 1024;

const quoteIfNeeded = (value: string) =>
  /^[\s"']|: |#|\s$/.test(value) ? JSON.stringify(value) : value;

export function buildSkillMarkdown(input: {
  description: string;
  instructions: string;
  name: string;
}): string {
  const description = input.description.replace(/\s+/g, " ").trim();
  const body = input.instructions.trim() || `# ${input.name}\n`;
  return `---\nname: ${input.name}\ndescription: ${quoteIfNeeded(description)}\n---\n\n${body}\n`;
}

/** Returns a user-facing problem with SKILL.md, or null when it looks valid. */
export function findSkillMarkdownProblem(markdown: string, expectedName: string): string | null {
  const match = /^---\r?\n([\s\S]*?)\r?\n---(?:\r?\n|$)/.exec(markdown);
  if (!match?.[1]) {
    return "SKILL.md must start with a --- frontmatter block.";
  }
  const field = (key: string) =>
    new RegExp(`^${key}:\\s*(.*)$`, "m")
      .exec(match[1] ?? "")?.[1]
      ?.trim()
      .replace(/^(["'])(.*)\1$/, "$2") ?? "";
  if (field("name") !== expectedName) {
    return `Frontmatter name must stay "${expectedName}". Duplicate the skill to rename it.`;
  }
  const description = field("description");
  if (!description) {
    return "Frontmatter needs a description so Codex knows when to use the skill.";
  }
  if (description.length > DESCRIPTION_MAX_LENGTH) {
    return `Description must be at most ${DESCRIPTION_MAX_LENGTH} characters.`;
  }
  return null;
}
